function StaffCard(props) {
    return (
        <div className="staff-card">
            <div className="staff-pic"><img src={props.img}></img></div>
            <h3 className="staff-name">{props.name}</h3>
            <p className="staff-user">{props.user + " (" + props.pronouns + ")"}</p>
            <div className="staff-bio">{props.bio}</div>
            <div className='staff-badge'><img src={props.badge}></img></div>
        </div>
    );
}
  
export default StaffCard;